module.exports = __webpack_public_path__ + "static/media/map-marker-selected.0d8f3dc5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/map-marker-selected.svg
// module id = 1396
// module chunks = 1